import { useAuth as useClerkAuth, useUser } from '@clerk/react'
import { useCallback } from 'react'

export interface AuthUser {
  id: string
  email?: string
  name?: string
  picture?: string
}

export function useAuth() {
  const { isLoaded, userId, getToken, signOut } = useClerkAuth()
  const { user: clerkUser } = useUser()

  const isAuthenticated = !!userId
  const isLoading = !isLoaded

  const user: AuthUser | null = clerkUser ? {
    id: clerkUser.id,
    email: clerkUser.primaryEmailAddress?.emailAddress,
    name: clerkUser.fullName ?? undefined,
    picture: clerkUser.imageUrl,
  } : null

  const getAccessToken = useCallback(async () => {
    return getToken()
  }, [getToken])

  const refreshUser = useCallback(async () => {
    // Clerk handles user synchronization automatically
  }, [])

  return {
    isAuthenticated,
    isLoading,
    user,
    refreshUser,
    getAccessToken,
    signIn: () => {
        // In Clerk, sign-in is typically handled by components like <SignInButton /> 
        // or by redirecting to a dedicated sign-in page. 
        // For compatibility with the existing ProtectedRoute, we might need a way to trigger it.
        window.location.href = '/sign-in' // Fallback or convention
    },
    signOut: () => signOut(),
  }
}
